import { InterfaceClient, InterfaceModes } from '@unifyapps/carbon/no-code/stores/InterfaceStore';

export const matrixClient = InterfaceClient.UA_MATRIX;
export const matrixMode = InterfaceModes.RUNNER;
